/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import {
  Checkbox,
  Loader,
  Modal,
  Radio,
  Dropdown,
  Form,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import cx from 'classnames';
import Update from 'immutability-helper';
import api from '../../api';
import { convertPropertiesToCamelCase } from '../../utils/shared';
import { convertWithScanOptionText, sortValueofAtoZ } from '../../constants/ScanOptionText';

class MyScanOptions extends Component {
  constructor(props) {
    super(props);
    this.modalAction = null;
    this.modalBody = null;
    this.state = {
      isLoading: false,
      isUseScanOption: false,
      isOpenAlert: false,
      isOpenModal: false,
      //scanOptions: [],
      //defaultSettings: [],
      scanOptionsWithArray: [],
      scanOptionsWithBoolean: [],
      scanOptionsWithString: [],
      defaultScanOptionsWithArray: [],
      defaultScanOptionsWithBoolean: [],
      defaultScanOptionsWithString: [],
    };
    this.handleRevert = this.handleRevert.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleOptionToggle = this.handleOptionToggle.bind(this);
    this.handleCheckChange = this.handleCheckChange.bind(this);
    this.handleToggleRadio = this.handleToggleRadio.bind(this);
    this.handleStringInputChange = this.handleStringInputChange.bind(this);
    this.handleStringAddition = this.handleStringAddition.bind(this);
    this.setMyScanOptions = this.setMyScanOptions.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    this.getMyScanOptions();
  }

  componentDidUpdate(prevProps, prevState) {
    const { isUseScanOption } = this.state;

    if (prevState.isUseScanOption !== isUseScanOption) {
      const element = document.getElementsByClassName('setting_issues_bottom');
      if (element.length === 0) {
        return;
      }
      if (isUseScanOption) {
        element[0].style.setProperty('bottom', '-275px');
      } else {
        element[0].style.setProperty('bottom', '-505px');
      }
    }
  }

  componentWillUnmount() {
  }

  handleOptionToggle(e) {
    const { t } = this.props;
    const { isUseScanOption } = this.state;

    if (e.target.text === t('system.button.on')) {
      if (isUseScanOption) {
        return;
      }
      return this.setState({
        isUseScanOption: true,
      });
    }
    if (!isUseScanOption) {
      return;
    }
    return this.setState({
      isUseScanOption: false,
    });
  }

  handleCheckChange = (e, selectedEntity, optionIndex, itemsIndex) => {
    const { scanOptionsWithArray } = this.state;
    const cloneArray = [...scanOptionsWithArray];

    const itemsArray = cloneArray[optionIndex].items;
    const updatedArray = Update(itemsArray[itemsIndex], { selected: { $set: !selectedEntity.selected } });
    const newData = Update(itemsArray, {
      $splice: [[itemsIndex, 1, updatedArray]],
    });

    cloneArray[optionIndex] = { ...cloneArray[optionIndex], items: newData };

    this.setState({
      scanOptionsWithArray: cloneArray,
    });
  };

  handleToggleRadio = (e, entity, option, index) => {
    const { scanOptionsWithBoolean } = this.state;
    const cloneArray = [...scanOptionsWithBoolean];

    const updatedItems = Update(cloneArray[index], { items: { $set: !entity } });
    const newData = Update(cloneArray, {
      $splice: [[index, 1, updatedItems]],
    });

    this.setState({
      scanOptionsWithBoolean: newData,
    });
  };

  handleStringInputChange = (e, items, index) => {
    const { scanOptionsWithString } = this.state;
    const cloneArray = [...scanOptionsWithString];
    if (e.target.classList[0] === 'search') {
      cloneArray[index].items.push(e.target.value);

      this.setState({
        scanOptionsWithString: cloneArray,
      });
    } else if (e.target.classList[0] === 'selected') {
      cloneArray[index].items.push(e.target.querySelector('b').textContent);

      this.setState({
        scanOptionsWithString: cloneArray,
      });
    } else {
      const filteredItems = cloneArray[index].items.filter((item) => {
        return item !== e.target.closest('.label').text;
      });

      const filteredOptions = cloneArray[index].selected_array.filter((item) => {
        return item.text !== e.target.closest('.label').text;
      });

      this.setState({
        scanOptionsWithString: Update(cloneArray, {
          [index]: {
            items: { $set: filteredItems },
            selected_array: { $set: filteredOptions },
          }
        })
      });
    }
  };

  handleStringAddition = (e, entity, index) => {
    const { scanOptionsWithString } = this.state;
    const cloneArray = [...scanOptionsWithString];
    let data;

    if (e.target.value) {
      data = {
        key: e.target.value,
        text: e.target.value,
        value: e.target.value,
      };
    } else {
      data = {
        key: e.target.querySelector('b').textContent,
        text: e.target.querySelector('b').textContent,
        value: e.target.querySelector('b').textContent,
      };
    }

    const checkUnique = cloneArray[index].selected_array.filter((item) => {
      return item.key === data.key;
    });

    if (checkUnique.length !== 0) {
      return;
    }

    cloneArray[index].selected_array.push(data);

    this.setState({
      scanOptionsWithString: cloneArray,
    });
  };

  handleRevert = () => {
    const {
      defaultScanOptionsWithArray,
      defaultScanOptionsWithBoolean,
      defaultScanOptionsWithString
    } = this.state;

    this.setState({
      scanOptionsWithArray: defaultScanOptionsWithArray,
      scanOptionsWithBoolean: defaultScanOptionsWithBoolean,
      scanOptionsWithString: defaultScanOptionsWithString,
    });
  };

  handleSave = () => {
    const { t } = this.props;
    const {
      scanOptionsWithArray,
      isUseScanOption
    } = this.state;
    let openAlert = false;

    const options = scanOptionsWithArray.map((o) => {
      const filteredItem = o.items.filter((f) => {
        return !f.selected;
      });

      if (filteredItem.length === o.items.length) {
        openAlert = true;
        return openAlert;
      }
      openAlert = false;
      return openAlert;
    });

    if (options.indexOf(true) > -1 && isUseScanOption) {
      this.modalAction = t('modal.title.attention');
      this.modalBody = t('modal.new_scan.error.error_option_select_category');
      return this.setState({
        isOpenAlert: true,
      });
    }

    this.modalAction = t('modal.title.attention');
    this.modalBody = t('my_page.save_scan_option');
    this.setState({
      isOpenModal: true,
    });
  };

  getMyScanOptions() {
    const { t } = this.props;
    this.setState({
      isLoading: true,
    }, () => {
      api
        .getMyScanOptions()
        .then((response) => {
          const data = convertPropertiesToCamelCase(response.response);

          const scanOptionsWithArrayRes = [];
          const scanOptionsWithBooleanRes = [];
          const scanOptionsWithStringRes = [];

          data.scanOption.map((option) => {
            if (Array.isArray(option.items)) {
              return scanOptionsWithArrayRes.push(option);
            }
            if (typeof option.items === 'boolean' || option.items instanceof Boolean) {
              return scanOptionsWithBooleanRes.push(option);
            }
            let selectedValue = [];
            let optionList = [];
            if (option.items !== '') {
              const splitWords = option.items.split(':');
              const newArray = splitWords.map((item) => {
                selectedValue.push(item);
                return {
                  key: item,
                  text: item,
                  value: item,
                };
              });
              optionList = newArray;
            } else {
              optionList = [];
              selectedValue = [];
            }
            const newData = {
              display_option: option.display_option,
              items: selectedValue,
              selected_array: optionList,
              option: option.option,
            };

            return scanOptionsWithStringRes.push(newData);
          });

          this.setState({
            scanOptionsWithArray: scanOptionsWithArrayRes,
            scanOptionsWithBoolean: scanOptionsWithBooleanRes,
            scanOptionsWithString: scanOptionsWithStringRes,
            defaultScanOptionsWithArray: scanOptionsWithArrayRes,
            defaultScanOptionsWithBoolean: scanOptionsWithBooleanRes,
            defaultScanOptionsWithString: scanOptionsWithStringRes,
            isUseScanOption: data.useScanOption,
            isLoading: false,
          });
        })
        .catch((err) => {
          console.log(err);
          const o = err.data.response;
          this.modalAction = t('modal.title.attention');
          if (o.error_description) {
            this.modalBody = o.error_description;
            this.setState({
              isLoading: false,
              isOpenAlert: true,
            });
          }
        });
    });
  }

  setMyScanOptions() {
    const {
      isUseScanOption,
      scanOptionsWithArray,
      scanOptionsWithBoolean,
      scanOptionsWithString,
    } = this.state;
    const { t } = this.props;
    const newOptions = {};

    scanOptionsWithArray.map((entity) => {
      let i = 0;
      const items = [];
      for (i; i < entity.items.length; i++) {
        if (entity.items[i].selected) {
          items.push(entity.items[i].item);
        }
      }
      newOptions[entity.option] = items;
      return null;
    });

    scanOptionsWithBoolean.map((entity) => {
      newOptions[entity.option] = entity.items;
      return null;
    });

    scanOptionsWithString.map((entity) => {
      let newItems;
      entity.items.map((item, index) => {
        if (index === 0) {
          newItems = `${item}`;
        } else {
          newItems = `${newItems}:${item}`;
        }
        return newItems;
      });
      newOptions[entity.option] = newItems || '';
      return null;
    });

    const obj = {
      use_scan_option: isUseScanOption,
      scan_option: newOptions,
    };

    this.setState({
      isOpenModal: false,
      isLoading: true,
    }, () => {
      api
        .setMyScanOptions(obj)
        .then((response) => {
          const data = convertPropertiesToCamelCase(response.response);

          const scanOptionsWithArrayRes = [];
          const scanOptionsWithBooleanRes = [];
          const scanOptionsWithStringRes = [];

          data.scanOption.map((option) => {
            if (Array.isArray(option.items)) {
              return scanOptionsWithArrayRes.push(option);
            }
            if (typeof option.items === 'boolean' || option.items instanceof Boolean) {
              return scanOptionsWithBooleanRes.push(option);
            }
            let selectedValue = [];
            let optionList = [];
            if (option.items !== '') {
              const splitWords = option.items.split(':');
              const newArray = splitWords.map((item) => {
                selectedValue.push(item);
                return {
                  key: item,
                  text: item,
                  value: item,
                };
              });
              optionList = newArray;
            } else {
              optionList = [];
              selectedValue = [];
            }
            const newData = {
              display_option: option.display_option,
              items: selectedValue,
              selected_array: optionList,
              option: option.option,
            };

            return scanOptionsWithStringRes.push(newData);
          });

          this.setState({
            scanOptionsWithArray: scanOptionsWithArrayRes,
            scanOptionsWithBoolean: scanOptionsWithBooleanRes,
            scanOptionsWithString: scanOptionsWithStringRes,
            defaultScanOptionsWithArray: scanOptionsWithArrayRes,
            defaultScanOptionsWithBoolean: scanOptionsWithBooleanRes,
            defaultScanOptionsWithString: scanOptionsWithStringRes,
            isUseScanOption: data.useScanOption,
            isLoading: false,
          });
        })
        .catch((err) => {
          console.log(err);
          const o = err.data.response;
          this.modalAction = t('modal.title.attention');

          if (o.error_description) {
            this.modalBody = o.error_description;
            this.setState({
              isLoading: false,
              isOpenAlert: true,
            });
          } else if (o.error === '422-224') {
            this.modalBody = t('modal.new_scan.error.error_option_select_category');
            this.setState({
              isLoading: false,
              isOpenAlert: true,
            });
          } else if (o.error === '422-211') {
            this.modalBody = t('modal.error.error_422_211');
            this.setState({
              isLoading: false,
              isOpenAlert: true,
            });
          } else if (o.error === '422-223') {
            this.modalBody = t('modal.error.error_422_223');
            this.setState({
              isLoading: false,
              isOpenAlert: true,
            });
          }
        });
    });
  }

  closeModal() {
    this.setState({
      isOpenModal: false,
      isOpenAlert: false,
    });
  }

  render() {
    const {
      isLoading,
      isUseScanOption,
      scanOptionsWithArray,
      scanOptionsWithBoolean,
      scanOptionsWithString,
    } = this.state;
    const { t } = this.props;

    const renderIfReady = (element) => {
      return isLoading ? (
        <Loader size="big" style={{ display: 'block', lineHeight: '25px' }}>
          {t('modal.message.loading')}
        </Loader>
      ) : element;
    };

    const renderItems = (array, optionIndex) => {
      if (Array.isArray(array)) {
        const newArray = sortValueofAtoZ(array);
        return newArray.map((entity, itemsIndex) => {
          return (
            <Form.Field key={entity.item}>
              <Checkbox
                label={convertWithScanOptionText(entity.item)}
                value={entity.item}
                checked={entity.selected}
                onChange={
                  (e) => {
                    return this.handleCheckChange(e, entity, optionIndex, itemsIndex);
                  }
                }
              />
            </Form.Field>
          );
        });
      }
    };

    return (
      <div style={{ position: 'relative' }}>
        <div className="contents_header">
          <div className="contents_header_inner">
            <h3 className="content_title">
              {t('my_page.scan_options')}
            </h3>
          </div>
        </div>
        {renderIfReady(
          <div className="setting_issues_content">
            <div className="setting_issues_content_item_wrap">
              <h3>{t('my_page.set_scan_options')}</h3>
              <div className="setting_issues_content_item">
                <div className="switch">
                  <a
                    className={cx(
                      {
                        checked: isUseScanOption,
                      }
                    )}
                    onClick={this.handleOptionToggle}
                    onKeyUp={this.handleOptionToggle}
                  >
                    {t('system.button.on')}
                  </a>
                  <a
                    className={cx(
                      {
                        checked: !isUseScanOption,
                      }
                    )}
                    onClick={this.handleOptionToggle}
                    onKeyUp={this.handleOptionToggle}
                  >
                    {t('system.button.off')}
                  </a>
                </div>
                {
                  isUseScanOption ? (
                    <p className="text">
                      {t('my_page.use_scan_option')}
                    </p>
                  ) : (
                    <p className="text">
                      {t('my_page.not_use_scan_option')}
                    </p>
                  )
                }
              </div>
            </div>
            {
              isUseScanOption ? (
                <Form style={{ marginTop: '52px' }}>
                  <h3>
                    {t('modal.new_scan.title.scan_options_type')}
                  </h3>
                  {
                    scanOptionsWithArray.length !== 0
                    && (
                      <Form.Group widths="equal" style={{ marginTop: '30px' }}>
                        {

                          scanOptionsWithArray.map((list, index) => {
                            return (
                              <Form.Field key={list.option}>
                                <label style={{ marginBottom: '1rem' }}>{list.display_option}</label>
                                {renderItems(list.items, index)}
                              </Form.Field>
                            );
                          })
                        }
                      </Form.Group>
                    )
                  }
                  {
                    (scanOptionsWithBoolean.length !== 0 || scanOptionsWithString.length !== 0)
                    && <div className="line" />
                  }
                  {
                    scanOptionsWithBoolean.length !== 0
                    && (
                      <Form.Group widths="equal" style={{ marginTop: '30px' }}>
                        {
                          scanOptionsWithBoolean.map((list, index) => {
                            return (
                              <Form.Field key={list.option}>
                                <label style={{ marginBottom: '1rem' }}>{list.display_option}</label>
                                <Radio
                                  toggle
                                  checked={list.items}
                                  onChange={
                                    (e) => {
                                      return this.handleToggleRadio(e, list.items, list.option, index);
                                    }
                                  }
                                />
                              </Form.Field>
                            );
                          })
                        }
                      </Form.Group>
                    )
                  }
                  {
                    (scanOptionsWithArray.length !== 0 || scanOptionsWithString.length !== 0)
                    && <div className="line" />
                  }
                  {
                    scanOptionsWithString.length !== 0
                    && (
                      <Form.Group widths="equal" style={{ marginTop: '30px' }}>
                        {
                          scanOptionsWithString.map((list, index) => {
                            return (
                              <Form.Field key={list.option}>
                                <label style={{ marginBottom: '1rem' }}>{list.display_option}</label>
                                <Dropdown
                                  multiple
                                  selection
                                  allowAdditions
                                  additionLabel={t('modal.button.add')}
                                  fluid
                                  search
                                  options={list.selected_array}
                                  value={list.items}
                                  onChange={
                                    (e) => {
                                      return this.handleStringInputChange(e, list.items, index);
                                    }
                                  }
                                  onAddItem={
                                    (e) => {
                                      return this.handleStringAddition(e, list, index);
                                    }
                                  }
                                  noResultsMessage={null}
                                />
                              </Form.Field>
                            );
                          })
                        }
                      </Form.Group>
                    )
                  }
                </Form>
              ) : null
            }
            <div className="setting_issues_bottom" style={{ padding: '0 30px', bottom: '-275px', position: 'absolute' }}>
              {
                isUseScanOption
                && <a className="revert" onClick={this.handleRevert} onKeyUp={this.handleRevert}>{t('settings.button.revert')}</a>
              }
              <a className="save" onClick={this.handleSave} onKeyUp={this.handleSave}>{t('modal.button.save')}</a>
            </div>
          </div>
        )}
        <Modal open={this.state.isOpenModal} onClose={this.closeModal}>
          <div className="modal_popup_wrap confirm_wrap">
            <div className="modal_popup_box confirm_box">
              <div className="modal_popup confirm">
                <h2 className="title">{this.modalAction}</h2>
                <p className="text">{this.modalBody}</p>
                <div className="button_wrap">
                  <a className="left_button" onClick={this.closeModal} onKeyUp={this.closeModal}>
                    {t('modal.button.cancel')}
                  </a>
                  <a className="right_button" onClick={this.setMyScanOptions} onKeyUp={this.setMyScanOptions}>
                    {t('modal.button.save')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal open={this.state.isOpenAlert} onClose={this.closeModal}>
          <div className="modal_popup_wrap">
            <div className="modal_popup_box">
              <div className="modal_popup">
                <h2 className="title">{this.modalAction}</h2>
                <p className="text">{this.modalBody}</p>
                <div className="button_wrap">
                  <a
                    className="center_button"
                    style={{ cursor: 'pointer' }}
                    onClick={this.closeModal}
                    onKeyUp={this.closeModal}
                  >
                    {t('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
export default withTranslation()(MyScanOptions);
